<div class="card card-stretch h-100 rounded-0 context-menu">
    <div class="card-header p-3 d-flex justify-content-between border-bottom-0">
        <h5 class="card-title mb-0 font-weight-bolder">
            <img src="../../../../assets/common/images/Activities/LeaveRequest.svg" class="h-20px w-20px rounded mr-2" />{{'TeamTimesheetRequest'|localize}}
        </h5>
        <div *ngIf="visible  && primengTableHelper.records.length > 0" class="ml-auto cursor-pointer card-toolbar">
            <div class="font-weight-bolder text-primary cursor-pointer" (click)="viewall()">
                {{ 'ViewAll' | localize}}
            </div>
        </div>
    </div>

    <div class="card-body p-0 pb-3">
        <div *ngIf="isLoading && !visible">
            <div *ngFor="let x of [1, 2, 3, 4]">

                <div class="row px-4">
                    <div class="col-md-2">

                        <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                    </div>

                    <div class="col-md-2">

                        <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                    </div>

                    <div class="col-md-2">

                        <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                    </div>

                    <div class="col-md-2">

                        <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                    </div>
                    <div class="col-md-2">

                        <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                    </div>

                    <div class="col-md-2">

                        <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                    </div>

                </div>

            </div>
        </div>



        <div class="d-flex flex-column justify-content-between px-4" id="timesheet-request" *ngIf="(!isLoading && visible) && primengTableHelper.records && primengTableHelper.records.length !== 0">
            <p-table [value]="primengTableHelper.records" [rows]="5" [paginator]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th style="width: 3rem" *ngIf="!isMyTimesheet" class="bg-light">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>-->
                        <th class="bg-light text-dark-65" *ngIf="!isMyTimesheet">{{'Members'|localize}}</th>
                        <th class="bg-light text-dark-65">{{'ProjectName'|localize}}</th>
                        <th class="bg-light text-dark-65" style="width: 16%;">{{'TimesheetDate'|localize}}</th>
                        <th class="bg-light text-dark-65" *ngIf="!isMyTimesheet" style="width: 11%;">{{'TimeOffSubmittedOn'|localize}}</th>
                        <!-- <th class="bg-light text-dark-65 text-left" *ngIf="!isMyTimesheet" style="width: 6%;">{{'Leave' | localize}}</th> -->
                        <th class="bg-light text-dark-65 text-left" style="width: 10%;">{{'RequiredHrs'|localize}}</th>
                        <th class="bg-light text-dark-65 text-left" style="width: 10%;">{{'LoggedHrs'|localize}}</th>
                        <th class="bg-light text-dark-65 text-left" style="width: 8%;">{{'BilledHrs'|localize}}</th>
                        <th class="bg-light text-dark-65 text-left" style="width: 8%;">{{'Status'|localize}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-timesheet let-rowIndex="rowIndex">
                    <tr class="selectable-row pointer border border-left-0 border-right-0 border-top-0 bg-hover-gray-100"
                          id="pointerClassOrg">
                        <!-- <td *ngIf="!isMyTimesheet" (click)="_tus.stopEventPropogation($event)">
                        <p-tableCheckbox [value]="timesheet"></p-tableCheckbox>
                    </td>-->
                        <!-- <td *ngIf="!isMyTimesheet">
                        <div class="row">
                            <div class="col col-auto pr-0">
                                <div class=" rounded">
                                    <img class=" w-35px h-35px img-fluid border border-light rounded p-1" id="profimgsize"
                                         src="{{ timesheet.userProfileImage || 'assets/common/images/default-profile-picture1.svg' }}" />
                                </div>
                            </div>
                            <div class="col col-auto">
                                <div>
                                    <span class="d-flex">
                                        <span class="font-weight-bold" *ngIf="timesheet?.userName"
                                              pTooltip="{{ timesheet.userName }}"
                                              [tooltipDisabled]="_tus.showTooltipForString(timesheet.userName, 15)"
                                              tooltipPosition="bottom">
                                            {{ timesheet.userName | slice:0:15 }}{{
                                    timesheet.userName.length > 15 ? '...' : ''
                                            }}
                                        </span>
                                    </span>
                                </div>
                                <div class="d-flex justify-content-start align-items-center text-muted">
                                    <small>{{ timesheet.userRole?.toString().replace(',' , ', ') }}</small>
                                </div>
                            </div>
                        </div>
                    </td> -->
                        <td *ngIf="!isMyTimesheet && timesheet">
                            <div class="row">
                                <div class="col col-auto pr-0">
                                    <div class="rounded">
                                        <img class="w-35px h-35px img-fluid border border-light rounded p-1" id="profimgsize"
                                             [src]="timesheet.userProfileImage || 'assets/common/images/default-profile-picture1.svg'" />
                                    </div>
                                </div>
                                <div class="col col-auto">
                                    <div>
                                        <span class="d-flex">
                                            <span class="font-weight-bold" *ngIf="timesheet.userName"
                                                  pTooltip="{{ timesheet.userName }}"
                                                  [tooltipDisabled]="_tus.showTooltipForString(timesheet.userName, 15)"
                                                  tooltipPosition="bottom">
                                                {{ timesheet.userName | slice:0:15 }}{{
                                                        timesheet.userName.length > 15 ? '...' : ''
                                                }}
                                            </span>
                                        </span>
                                    </div>
                                    <div class="d-flex justify-content-start align-items-center text-muted">
                                        <!-- your-component.component.html -->
                                        <small pTooltip="{{ (timesheet.userRole) ? timesheet.userRole.toString().replace(',' , ', ') : '-' }}"
                                            tooltipPosition="bottom">
                                            {{ (timesheet.userRole?.toString().replace(',' , ', ')).slice(0, 15) }}{{ timesheet.userRole?.toString().replace(','
                                            , ', ').length > 15 ? '...' : '' }}
                                        </small>

                                     </div>
                                </div>
                            </div>
                        </td>


                        <td>
                            <div class="row">
                                <div class="col col-auto pr-0">
                                    <div class=" d-flex align-items-center ">
                                        <img class="w-35px h-35px img-fluidborder border-light rounded p-1" id="profimgsize"
                                             src="{{ timesheet.projectImage || 'assets/common/images/projects/default image for project -1.png' }}" />
                                    </div>
                                </div>


                                <div class="col col-auto">
                                    <span class="d-flex">
                                        <span pTooltip="{{ timesheet.projectName }}"
                                              [tooltipDisabled]="_tus.showTooltipForString(timesheet.projectName, 15)"
                                              tooltipPosition="bottom">
                                            {{ timesheet.projectName | slice:0:15 }}{{
                                        timesheet.projectName.length > 15 ? '...' : ''
                                            }}
                                        </span>
                                    </span>

                                    <span class="d-flex">
                                        <span class="mr-1">
                                            <img *ngIf="timesheet?.projectType===1" src="assets/common/images/billable.png"
                                                 alt="" width="15px" class="ml-1" pTooltip="{{'Billable' |localize}}"
                                                 tooltipPosition="bottom">

                                            <img *ngIf="timesheet?.projectType===2"
                                                 src="assets/common/images/nonbillable.png" alt="" width="15px" class="ml-1"
                                                 pTooltip="{{'NonBillable' |localize}}" tooltipPosition="bottom"> |
                                        </span>
                                        <span *ngIf="timesheet.projectCurrentStatus == 1"
                                              class="text-dark-50 font-size-xs mr-2 mt-1">{{'New' | localize}}</span>
                                        <span *ngIf="timesheet.projectCurrentStatus == 2"
                                              class="text-dark-50 font-size-xs mr-2 mt-1">{{'Active' | localize}}</span>
                                        <span *ngIf="timesheet.projectCurrentStatus == 3"
                                              class="text-dark-50 font-size-xs mr-2 mt-1">{{'Complete' | localize}}</span>
                                        <span *ngIf="timesheet.projectCurrentStatus == 4"
                                              class="text-dark-50 font-size-xs mr-2 mt-1">{{'Closed' | localize}}</span>
                                        <span *ngIf="!timesheet.projectCurrentStatus"
                                              class="text-dark-50 font-size-xs mr-2 mt-1">{{'Notavailable'|localize}}</span>

                                    </span>

                                    <!--<project-status-badge [status]="timesheet?.projectCurrentStatus"></project-status-badge>-->
                                </div>
                            </div>
                        </td>

                        <td>
                            <div class="font-size-sm" *ngIf="timesheet.fromDate.year !== 1 && timesheet.toDate.year !== 1">

                                <div>
                                    {{ _tus.getLocalJsDate(timesheet.fromDate) | dateFormatJs }}<span *ngIf="!_tus.isDateSame(_tus.getLocalJsDate(timesheet.fromDate), _tus.getLocalJsDate(timesheet.toDate))">
                                        - {{ _tus.getLocalJsDate(timesheet.toDate) | dateFormatJs }}
                                    </span><span class="font-size-sm d-flex justify-content-start align-items-center mt-1 ml-2 position-relative w-20px"
                                                 style="display: inline !important;">
                                        <!--<a class="mr-1"><i class="far fa-comment-alt timesheet-comments-icon icon-md pointer"></i></a>-->
                                        <!--<span id="timesheet-unread-badge-id-{{ timesheet.id }}" *ngIf="timesheet.unReadCount" style="height: 11px;width: 11px;font-size: 0.55rem;border-radius: 0.35rem;top: -3px;right: 0;" class="label label-sm label-rounded label-danger position-absolute">{{ timesheet.unReadCount }}</span>-->
                                    </span>
                                </div>

                            </div>
                            <div class="text-dark-65"
                                 *ngIf="timesheet.fromDate.year === 1 || timesheet.toDate.year === 1 || !timesheet?.fromDate || !timesheet?.toDate">
                                {{'NonBillable'|localize}}
                            </div>
                        </td>

                        <td>
                            <span>{{ timesheet.submitedDate | date:dateFormat }}</span>
                        </td>

                        <!-- <td *ngIf="!isMyTimesheet">
                        <span>{{ _tus.getLocalJsDate(timesheet.submitedDate) | dateFormatJs }}</span>
                    </td> -->
                        <!-- <td class="text-left text-success font-weight-bold" *ngIf="!isMyTimesheet">
                        {{timesheet.leave}}
                    </td> -->

                        <td class="text-left">
                            <span class="text-info font-weight-bold">
                                {{
                                        _tus.getHoursAndMinStringWithColon(timesheet.requiredHours)
                                }}
                            </span>
                        </td>

                        <td class="text-left">
                            <span class=" text-warning font-weight-bold">
                                {{
                                        _tus.getHoursAndMinStringWithColon(timesheet.submitedHours)
                                }}
                            </span>
                        </td>


                        <td class="text-left">
                            <span class="text-success font-weight-bold">
                                {{ _tus.getHoursAndMinStringWithColon(timesheet.billedHours)}}
                            </span>
                        </td>

                        <td class="text-left">
                            <!--                        <timesheet-status-badge [status]="timesheet.timesheetStatus"></timesheet-status-badge>



                        -->


                            <span class="label label-outline-secondary label-pill label-inline mr-2"
                                  style="border-radius: 1.42rem !important; font-size: 0.84rem; font-weight: 500;">
                                <span [ngClass]="{'label-success': timesheet.timesheetStatus === 1 , 'label-warning': timesheet.timesheetStatus === 2 , 'label-danger': timesheet.timesheetStatus === 3, 'label-orange': timesheet.timesheetStatus === 4}"
                                      class="label label-dot mr-2"></span>
                                <span *ngIf="timesheet.timesheetStatus === 1">{{'Approved'|localize}}</span>
                                <span *ngIf="timesheet.timesheetStatus === 2">{{'Pending'|localize}}</span>
                                <span *ngIf="timesheet.timesheetStatus === 3">{{'Rejected'|localize}}</span>
                                <span *ngIf="timesheet.timesheetStatus === 4">{{'Overdue'|localize}}</span>
                            </span>
                        </td>
                    </tr>

                </ng-template>
            </p-table>

        </div>




        <div  *ngIf="primengTableHelper?.records && primengTableHelper?.records.length === 0">


            <div class="d-flex flex-column justify-content-center align-items-center px-4 pt-4 h-100"
                 >
                <img *ngIf="isMyTimesheet" src="assets/common/images/time-sheet/my-timesheet-empty-state.PNG"
                     class="w-300px mb-3" />
                <img *ngIf="!isMyTimesheet" src="assets/common/images/time-sheet/team-timesheet-empty-state.PNG"
                     class="w-300px mb-3" />
                <h6 class="my-3 text-muted text-center mt-2">{{ 'NoDataFounds' | localize }}</h6>
            </div>
        </div>



    </div>
